var avatarOutline = 'fx_e395032e_1ma9xuy1';
var avatarOutlineStrokeWidth = 'var(--fx_e395032e_1ma9xuy0)';
var avatarOutlineSvgPath = 'fx_e395032e_1ma9xuy3';
var avatarOutlineSvgSize = 'var(--fx_e395032e_1ma9xuy2)';

export { avatarOutline, avatarOutlineStrokeWidth, avatarOutlineSvgPath, avatarOutlineSvgSize };
//# sourceMappingURL=outline.vanilla.mjs.map
